import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";

// Components imports
import InputField from "../../components/common/InputField";
import Button from "../../components/common/Button";
import NavigationBar from "../../components/common/NavigationBar";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  getCurrentUserData,
  updateCurrentUserData,
  manuallyTrigerSuccess,
  updateCurrentUserPassword,
} from "../../redux/actions/currentUserActions";

import { logout } from "../../redux/actions/loginAction";

// Scss imports
import css from "./UserPanel.module.scss";

interface UserPanelProps {
  text?: string;
}

const UserPanel: React.FC<UserPanelProps> = ({}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  // Curent user data
  const currentUserData = useSelector(
    (state: any) => state.currentUser.currentUserData
  );

  // Updation fields status
  const updateCurrentUserDataStatus = useSelector(
    (state: any) => state.currentUser.updateCurrentUserDataStatus
  );

  // Updating fields error
  const updateCurrentUserDataError = useSelector(
    (state: any) => state.currentUser.updateCurrentUserDataError
  );
  // Setting up state to hold data for forms
  const [firstName, setFirstName] = useState(currentUserData.firstName);
  const [lastName, setLastName] = useState(currentUserData.lastName);
  const [businessName, setBusinessName] = useState(
    currentUserData.businessName
  );
  const [nationalId, setNationalId] = useState(currentUserData.nationalId);
  const [email, setEmail] = useState(currentUserData.email);
  const [phone, setPhone] = useState(currentUserData.phone);
  const [place, setPlace] = useState(currentUserData.place);
  const [municipality, setMunicipality] = useState(
    currentUserData.municipality
  );
  const [street, setStreet] = useState(currentUserData.street);
  const [buildingNumber, setBuildingNumber] = useState(
    currentUserData.buildingNumber
  );
  const [apartmentNumber, setApartmentNumber] = useState(
    currentUserData.apartmentNumber
  );
  const [letter, setLetter] = useState(currentUserData.letter);
  const [floor, setFloor] = useState(currentUserData.floor);
  const [zipCode, setZipCode] = useState(currentUserData.zipCode);
  const [subscriptionDate, setSubscriptionDate] = useState(
    currentUserData.subscriptionDate
  );
  const [subscriptionLeft, setSubscriptionLeft] = useState(
    currentUserData.subscriptionLeft
  );
  const [identificationNumber, setIdentificationNumber] = useState(
    currentUserData.identificationNumber
  );
  const [subscriptionTime, setSubscriptionTime] = useState(
    currentUserData.subscriptionTime
  );
  const [taxId, setTaxId] = useState(currentUserData.taxId);
  const [sendingBlock, setSendingBlock] = useState("");

  // messages text states
  const [messageBasicAccountText, setMessageBasicAccoutText] = useState("");
  const [messageContactText, setMessageContactText] = useState("");
  const [messageResidenceText, setMessageResidenceText] = useState("");
  const [messageChangePasswordText, setMessageChangePasswordText] =
    useState("");

  // password states
  const [passwordCurrent, setPasswordCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  // status for disabled password button
  const [disabledPaswordButton, setDisabledPaswordButton] = useState(false);

  useEffect(() => {
    if (sendingBlock === "basicData") {
      handleMessageText(setMessageBasicAccoutText);
    } else if (sendingBlock === "contact") {
      handleMessageText(setMessageContactText);
    } else if (sendingBlock === "residence") {
      handleMessageText(setMessageResidenceText);
    } else if (sendingBlock === "changePassword") {
      handleMessageText(setMessageChangePasswordText);
    }
  }, [
    updateCurrentUserData,
    updateCurrentUserDataStatus,
    updateCurrentUserPassword,
  ]);

  useEffect(() => {
    if (
      updateCurrentUserDataError ===
      "Лозинка је промењена скоро! Молимо Вас пријавите се поново."
    ) {
      dispatch(logout(history));
    }
  }, [updateCurrentUserDataError]);

  useEffect(() => {
    setMessageBasicAccoutText("");
    setMessageContactText("");
    setMessageResidenceText("");
    setMessageChangePasswordText("");
  }, []);

  useEffect(() => {
    if (
      password.match("^(?=.*d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$") !=
      null
    ) {
      setPasswordConfirm("");
    }
  }, [password]);

  // Handling input change
  const handleChange = (e: any, setValue) => {
    setValue(e.target.value);
    setMessageBasicAccoutText("");
    setMessageContactText("");
    setMessageResidenceText("");
    setMessageChangePasswordText("");
    dispatch(manuallyTrigerSuccess());
  };

  // Function for checking is object empty
  const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };

  // Function for sending data to the database with certain conditions
  const sendDataToTheDatabase = (object, formData, setMessageText) => {
    if (!isEmpty(object)) {
      dispatch(updateCurrentUserData(formData()));
    } else {
      setMessageText("Није промењено ниједно поље!");

      setTimeout(() => {
        setMessageText("");
      }, 3000);
    }
  };

  // Event for sending basic data to the database
  const sendBasicDataEvent = () => {
    const basicDataForm = () => {
      return {
        ...(firstName !== currentUserData.firstName && {
          firstName: firstName,
        }),
        ...(businessName !== currentUserData.businessName && {
          businessName: businessName,
        }),
        ...(lastName !== currentUserData.lastName && { lastName: lastName }),
        ...(nationalId !== currentUserData.nationalId && {
          nationalId: nationalId,
        }),
        ...(identificationNumber !== currentUserData.identificationNumber && {
          identificationNumber: identificationNumber,
        }),
        ...(taxId !== currentUserData.taxId && {
          taxId: taxId,
        }),
      };
    };

    setSendingBlock("basicData");

    const object: any = basicDataForm();
    sendDataToTheDatabase(object, basicDataForm, setMessageBasicAccoutText);
  };

  // Event for sending residence data to the database
  const sendResidenceDataEvent = () => {
    const residenceDataForm = () => {
      return {
        ...(place !== currentUserData.place && {
          place: place,
        }),
        ...(municipality !== currentUserData.municipality && {
          municipality: municipality,
        }),
        ...(street !== currentUserData.street && {
          street: street,
        }),
        ...(buildingNumber !== currentUserData.buildingNumber && {
          buildingNumber: buildingNumber,
        }),
        ...(apartmentNumber !== currentUserData.apartmentNumber && {
          apartmentNumber: apartmentNumber,
        }),
        ...(floor !== currentUserData.floor && {
          floor: floor,
        }),
        ...(letter !== currentUserData.letter && {
          letter: letter,
        }),
        ...(zipCode !== currentUserData.zipCode && {
          zipCode: zipCode,
        }),
      };
    };

    setSendingBlock("residence");

    const object: any = residenceDataForm();

    sendDataToTheDatabase(object, residenceDataForm, setMessageResidenceText);
  };

  // Event for sending basic data to the database
  const sendContactDataEvent = () => {
    const contactDataForm = () => {
      return {
        ...(email !== currentUserData.email && {
          email: email,
        }),
        ...(phone !== currentUserData.phone && { phone: phone }),
      };
    };

    const object: any = contactDataForm();

    setSendingBlock("contact");

    sendDataToTheDatabase(object, contactDataForm, setMessageContactText);
  };

  // function for handling error/success messages
  const handleMessageText = (setMessageText) => {
    if (updateCurrentUserDataStatus === "fail") {
      setMessageText(updateCurrentUserDataError);
      setTimeout(() => {
        setMessageText("");
      }, 3000);
    } else if (updateCurrentUserDataStatus === "success") {
      setMessageText("Успешно сте променили основне податке профила!");
      setTimeout(() => {
        setMessageText("");
      }, 3000);
    }
  };

  // Change password event
  const changePasswordEvent = () => {
    const formData = () => {
      return {
        passwordCurrent: passwordCurrent,
        password: password,
        passwordConfirm: passwordConfirm,
      };
    };

    setSendingBlock("changePassword");
    const object: any = formData();

    if (passwordCurrent === "" || password === "" || passwordConfirm === "") {
      setMessageChangePasswordText("Попуни сва поља потребна за промену шифре");

      setTimeout(() => {
        setMessageChangePasswordText("");
      }, 3000);
    }

    if (
      passwordCurrent.length > 0 &&
      password.length > 0 &&
      passwordConfirm.length > 0
    ) {
      if (!isEmpty(object)) {
        dispatch(updateCurrentUserPassword(object));
      } else {
        setMessageChangePasswordText("Није промењено ниједно поље!");

        setTimeout(() => {
          setMessageChangePasswordText("");
        }, 3000);
      }
    }
  };

  return (
    <div className={css.mainContainer}>
      <NavigationBar />
      <h1>Кориснички подаци</h1>
      <div className={css.dataContainer}>
        <div className={css.containerSubscription}>
          <div>
            <p>
              <span>Датум претплате: </span>
              {currentUserData.subscriptionDate
                ? currentUserData.subscriptionDate.split("T")[0]
                : ""}
            </p>
            <p>
              <span>Крај претплате: </span>
              {currentUserData.subscriptionLeft
                ? currentUserData.subscriptionLeft.split("T")[0]
                : ""}
            </p>
            <p>
              <span>Укупно време претплате: </span>
              {currentUserData.subscriptionTime}
            </p>
          </div>
          {/*<div className={css.updateDataContainer}>
           
            <div className={css.inputFieldWrapper}>
              <InputField
                label="Датум почетка претплате"
                name="subscriptionDate"
                id="name"
                type="date"
                placeholder="Унеси датум почетка претплате"
                value={subscriptionDate.split("T")[0]}
                handleChange={(e: any) => handleChange(e, setSubscriptionDate)}
                handleOnFocus={(e: any) => (e.target.placeholder = "")}
                handleOnBlur={(e: any) =>
                  (e.target.placeholder = "Унеси датум почетка претплате")
                }
                inputType="rowInput"
              />
            </div>
            <div className={css.inputFieldWrapper}>
              <InputField
                label="Преостало време"
                name="subscriptionLeft"
                id="subscriptionLeft"
                type="date"
                placeholder="Преостало време до краја претплате"
                value={subscriptionLeft.split("T")[0]}
                handleChange={(e: any) => handleChange(e, setSubscriptionLeft)}
                handleOnFocus={(e: any) => (e.target.placeholder = "")}
                handleOnBlur={(e: any) =>
                  (e.target.placeholder = "Преостало време до краја претплате")
                }
                inputType="rowInput"
              />
            </div>
            <div className={css.inputFieldWrapper}>
              <InputField
                label="Укупно време претплате"
                name="subscriptionTime"
                id="subscriptionTime"
                type="text"
                placeholder="Унеси укупно време претплате"
                value={subscriptionTime}
                handleChange={(e: any) => handleChange(e, setSubscriptionTime)}
                handleOnFocus={(e: any) => (e.target.placeholder = "")}
                handleOnBlur={(e: any) =>
                  (e.target.placeholder = "Унеси укупно време претплате")
                }
                inputType="rowInput"
              />
            </div>

            <div className={css.buttonWrapper}>
              <Button
                text="Пошаљи"
                onButtonClickHandler={onSendDataButtonClickHandler}
                style={{
                  borderRadius: "5rem",
                  maxHeight: "6rem",
                  border: "0.1rem solid gray"
                }}
              />
            </div>
          </div>*/}
        </div>
        {/* Basic account data */}
        <div className={css.wrapperContainer}>
          <div
            className={css.container}
            onClick={() => dispatch(getCurrentUserData())}
          >
            <div>
              <h2 className={css.title}>Основни кориснички подаци</h2>
              <hr />
              <p>
                <span>Име: </span>
                {currentUserData.firstName &&
                currentUserData.firstName.length > 0
                  ? currentUserData.firstName
                  : ""}
              </p>
              <p>
                <span>Презиме: </span>
                {currentUserData.lastName && currentUserData.lastName.length > 0
                  ? currentUserData.lastName
                  : ""}
              </p>

              {/* <p>
                <span>Јединствени матични број: </span>
                {currentUserData.nationalId &&
                currentUserData.nationalId.length > 0
                  ? currentUserData.nationalId
                  : ""}
              </p>
              <p>
                <span>Матични број: </span>
                {currentUserData.identificationNumber}
              </p>
              <p>
                <span>Порески број: </span>
                {currentUserData.taxId}
                </p>*/}
            </div>

            <div className={css.updateDataContainerWrapper}>
              <div className={css.updateDataContainer}>
                {/* Forms for updating data */}
                <div className={css.inputFieldWrapper}>
                  {currentUserData.firstName ? (
                    <InputField
                      label="Име"
                      name="firstName"
                      id="name"
                      type="text"
                      //placeholder="Унеси име"
                      value={firstName}
                      handleChange={(e: any) => handleChange(e, setFirstName)}
                      handleOnFocus={(e: any) => (e.target.placeholder = "")}
                      /*handleOnBlur={(e: any) =>
                    (e.target.placeholder = "Унеси име")
                  }*/
                      inputType="rowInput"
                    />
                  ) : (
                    <InputField
                      label="Име фирме"
                      name="businessName"
                      id="name"
                      type="text"
                      //placeholder="Унеси име"
                      value={businessName}
                      handleChange={(e: any) =>
                        handleChange(e, setBusinessName)
                      }
                      handleOnFocus={(e: any) => (e.target.placeholder = "")}
                      /*handleOnBlur={(e: any) =>
                    (e.target.placeholder = "Унеси име")
                  }*/
                      inputType="rowInput"
                    />
                  )}
                </div>
                {currentUserData.lastName ? (
                  <div className={css.inputFieldWrapper}>
                    <InputField
                      label="Презиме"
                      name="lastName"
                      id="lastName"
                      type="text"
                      //placeholder="Унеси презиме"
                      value={lastName}
                      handleChange={(e: any) => handleChange(e, setLastName)}
                      handleOnFocus={(e: any) => (e.target.placeholder = "")}
                      /*handleOnBlur={(e: any) =>
                    (e.target.placeholder = "Унеси презиме")
                  }*/
                      inputType="rowInput"
                    />
                  </div>
                ) : (
                  ""
                )}
                {/*currentUserData.nationalId && (
                  <div className={css.inputFieldWrapper}>
                    <InputField
                      label="Матични број"
                      name="nationalId"
                      id="nationalId"
                      type="text"
                      //placeholder="Матични број"
                      value={nationalId}
                      handleChange={(e: any) => handleChange(e, setNationalId)}
                      handleOnFocus={(e: any) => (e.target.placeholder = "")}
                  
                      inputType="rowInput"
                    />
                  </div>
                )*/}
                {/* <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Матични број фирме"
                    name="identificationNumber"
                    id="identificationNumber"
                    type="text"
                    //placeholder="Унеси матични број фирме"
                    value={identificationNumber}
                    handleChange={(e: any) =>
                      handleChange(e, setIdentificationNumber)
                    }
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                   
                    inputType="rowInput"
                  />
                  </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Порески број"
                    name="taxId"
                    id="taxId"
                    type="text"
                    //placeholder="Унеси презиме"
                    value={taxId}
                    handleChange={(e: any) => handleChange(e, setLastName)}
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                 
                    inputType="rowInput"
                  />
                </div>*/}
                <div className={css.buttonWrapper}>
                  <Button
                    text="Пошаљи"
                    onButtonClickHandler={sendBasicDataEvent}
                    style={{
                      borderRadius: "5rem",
                      maxHeight: "6rem",
                      border: "0.1rem solid gray",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${css.messageText} ${
              messageBasicAccountText ===
              "Успешно сте променили основне податке профила!"
                ? css.successMessageText
                : ""
            }`}
          >
            <p>{messageBasicAccountText}</p>
          </div>
        </div>
        {/* Residence data */}
        <div className={css.wrapperContainer}>
          <div className={css.container}>
            <div>
              <h3 className={css.title}>Подаци о пребивалишту</h3>
              <hr />
              <p>
                <span>Место: </span>
                {currentUserData.place}
              </p>
              <p>
                <span>Општина: </span>
                {currentUserData.municipality}
              </p>
              <p>
                <span>Улица: </span>
                {currentUserData.street}
              </p>
              <p>
                <span>Број зграде: </span>
                {currentUserData.buildingNumber}
              </p>
              <p>
                <span>Број стана: </span>
                {currentUserData.apartmentNumber}
              </p>
              <p>
                <span>Спрат: </span>
                {currentUserData.floor}
              </p>
              <p>
                <span>Слово: </span>
                {currentUserData.letter}
              </p>
              <p>
                <span>Поштански број: </span>
                {currentUserData.zipCode}
              </p>
            </div>
            <div className={css.updateDataContainerWrapper}>
              <div className={css.updateDataContainer}>
                {/* Forms for updating data */}
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Место"
                    name="place"
                    id="name"
                    type="text"
                    //placeholder="Београд"
                    value={place}
                    handleChange={(e: any) => handleChange(e, setPlace)}
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    //handleOnBlur={(e: any) => (e.target.placeholder = "Београд")}
                    inputType="rowInput"
                  />
                </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Општина"
                    name="municipality"
                    id="municipality"
                    type="text"
                    //placeholder="Савски Венац"
                    value={municipality}
                    handleChange={(e: any) => handleChange(e, setMunicipality)}
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    /*handleOnBlur={(e: any) =>
                    (e.target.placeholder = "Савски Венац")
                  }*/
                    inputType="rowInput"
                  />
                </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Улица"
                    name="street"
                    id="street"
                    type="text"
                    //placeholder="Балканска"
                    value={street}
                    handleChange={(e: any) => handleChange(e, setStreet)}
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    /*handleOnBlur={(e: any) =>
                    (e.target.placeholder = "Балканска")
                  }*/
                    inputType="rowInput"
                  />
                </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Број зграде"
                    name="buildingNumber"
                    id="buildingNumber"
                    type="text"
                    //placeholder="12"
                    value={buildingNumber}
                    handleChange={(e: any) =>
                      handleChange(e, setBuildingNumber)
                    }
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    //handleOnBlur={(e: any) => (e.target.placeholder = "12")}
                    inputType="rowInput"
                  />
                </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Број стана"
                    name="apartmentNumber"
                    id="apart"
                    type="text"
                    //placeholder="55"
                    value={apartmentNumber}
                    handleChange={(e: any) =>
                      handleChange(e, setApartmentNumber)
                    }
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    //handleOnBlur={(e: any) => (e.target.placeholder = "55")}
                    inputType="rowInput"
                  />
                </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Спрат"
                    name="floor"
                    id="floor"
                    type="text"
                    //placeholder="1"
                    value={floor}
                    handleChange={(e: any) => handleChange(e, setFloor)}
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    //handleOnBlur={(e: any) => (e.target.placeholder = "1")}
                    inputType="rowInput"
                  />
                </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Слово"
                    name="letter"
                    id="letter"
                    type="text"
                    //placeholder="А"
                    value={letter}
                    handleChange={(e: any) => handleChange(e, setLetter)}
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    //handleOnBlur={(e: any) => (e.target.placeholder = "А")}
                    inputType="rowInput"
                  />
                </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Поштански број"
                    name="zipCode"
                    id="apart"
                    type="text"
                    //placeholder="11000"
                    value={zipCode}
                    handleChange={(e: any) => handleChange(e, setZipCode)}
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    //handleOnBlur={(e: any) => (e.target.placeholder = "11000")}
                    inputType="rowInput"
                  />
                </div>
                <div className={css.buttonWrapper}>
                  <Button
                    text="Пошаљи"
                    onButtonClickHandler={sendResidenceDataEvent}
                    style={{
                      borderRadius: "5rem",
                      maxHeight: "6rem",
                      border: "0.1rem solid gray",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${css.messageText} ${
              messageResidenceText ===
              "Успешно сте променили основне податке профила!"
                ? css.successMessageText
                : ""
            }`}
          >
            <p>{messageResidenceText}</p>
          </div>
        </div>

        {/*Contact data */}
        <div className={css.wrapperContainer}>
          <div className={css.container}>
            <div>
              <h2 className={css.title}>Контакт подаци</h2>
              <hr />
              <p>
                <span>Имејл адреса: </span>
                {currentUserData.email}
              </p>
              <p>
                <span>Број телефона: </span>
                {currentUserData.phone}
              </p>
            </div>
            <div className={css.updateDataContainerWrapper}>
              <div className={css.updateDataContainer}>
                {/* Forms for updating data */}
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Имејл адреса"
                    name="email"
                    id="email"
                    type="email"
                    //placeholder="email@gmail.com"
                    value={email}
                    handleChange={(e: any) => handleChange(e, setEmail)}
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    /*handleOnBlur={(e: any) =>
                    (e.target.placeholder = "email@gmail.com")
                  }*/
                    inputType="rowInput"
                  />
                </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Број телефона"
                    name="phone"
                    id="phone"
                    type="text"
                    //placeholder="0600001222"
                    value={phone}
                    handleChange={(e: any) => handleChange(e, setPhone)}
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    /*handleOnBlur={(e: any) =>
                    (e.target.placeholder = "0600001222")
                  }*/
                    inputType="rowInput"
                  />
                </div>

                <div className={css.buttonWrapper}>
                  <Button
                    text="Пошаљи"
                    onButtonClickHandler={sendContactDataEvent}
                    style={{
                      borderRadius: "5rem",
                      maxHeight: "6rem",
                      border: "0.1rem solid gray",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className={`${css.messageText} ${
              messageContactText ===
              "Успешно сте променили основне податке профила!"
                ? css.successMessageText
                : ""
            }`}
          >
            <p>{messageContactText}</p>
          </div>
        </div>

        {/* Changing password */}
        <div className={css.wrapperContainer}>
          <div className={css.container}>
            <div>
              <h2 className={css.title}>Промена шифре</h2>
            </div>
            <div className={css.updateDataContainerWrapper}>
              <div className={css.updateDataContainer}>
                {/* Forms for updating data */}
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Тренутна шифра"
                    name="passwordCurrent"
                    id="passwordCurrent"
                    type="password"
                    //placeholder="Шифра789"
                    value={passwordCurrent}
                    handleChange={(e: any) =>
                      handleChange(e, setPasswordCurrent)
                    }
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    //handleOnBlur={(e: any) => (e.target.placeholder = "Шифра789")}
                    inputType="rowInput"
                  />
                </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Нова шифра"
                    name="password"
                    id="password"
                    type="password"
                    //placeholder="Шифра456"
                    value={password}
                    handleChange={(e: any) => {
                      handleChange(e, setPassword);
                      if (
                        password.match(
                          "^(?=.*d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"
                        ) == null
                      ) {
                        setMessageChangePasswordText(
                          "Шифра треба да има најмање осам карактера, барем једно велико слово, барем једино мало слово и барем један број"
                        );
                      }
                    }}
                    handleOnFocus={(e: any) => {
                      e.target.placeholder = "";
                      if (
                        password.match(
                          "^(?=.*d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"
                        ) == null
                      ) {
                        setMessageChangePasswordText(
                          "Шифра треба да има најмање осам карактера, барем једно велико слово, барем једино мало слово и барем један број"
                        );
                      }
                    }}
                    //handleOnBlur={(e: any) => (e.target.placeholder = "Шифра456")}
                    inputType="rowInput"
                  />
                </div>
                <div className={css.inputFieldWrapper}>
                  <InputField
                    label="Потврда шифре"
                    name="passwordConfirm"
                    id="passwordConfirm"
                    type="passwordConfirm"
                    //placeholder="Шифра456"
                    value={passwordConfirm}
                    handleChange={(e: any) =>
                      handleChange(e, setPasswordConfirm)
                    }
                    handleOnFocus={(e: any) => (e.target.placeholder = "")}
                    //handleOnBlur={(e: any) => (e.target.placeholder = "Шифра456")}
                    inputType="rowInput"
                  />
                </div>

                <div className={css.buttonWrapper}>
                  <Button
                    text="Пошаљи"
                    onButtonClickHandler={changePasswordEvent}
                    style={{
                      borderRadius: "5rem",
                      maxHeight: "6rem",
                      border: "0.1rem solid gray",
                    }}
                    disabledButton={disabledPaswordButton}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${css.messageText} ${
              messageContactText ===
              "Успешно сте променили основне податке профила!"
                ? css.successMessageText
                : ""
            }`}
          >
            <p>{messageChangePasswordText}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPanel;
